import {Injectable, signal} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ChatServiceService {
  /** Signal-backed so OnPush components (the new assistant) see opens from the nav and home page. */
  private readonly openState = signal(false);
  readonly isOpen = this.openState.asReadonly();

  get toggle(): boolean {
    return this.openState();
  }

  set toggle(value: boolean) {
    this.openState.set(value);
  }

  /** Element that opened the chat, so focus can return to it on close. */
  private opener: HTMLElement | null = null;

  openChatBot() {
    if (!this.toggle) {
      const active = document.activeElement;
      this.opener = active instanceof HTMLElement && active !== document.body ? active : null;
    }

    this.toggle = !this.toggle;
  }

  /** Closes the chat and returns focus to whatever opened it. Returns that element, if any. */
  closeChatBot(): HTMLElement | null {
    this.toggle = false;
    const opener = this.opener;
    this.opener = null;
    setTimeout(() => opener?.isConnected && opener.focus());
    return opener;
  }
}
